/* tslint:disable */
/* eslint-disable */
/**
 * AIS Coverage API
 * API for managing AIS source identifiers and calculating coverage.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourceIdentifier
 */
export interface SourceIdentifier {
    /**
     * 
     * @type {number}
     * @memberof SourceIdentifier
     */
    id: number;
    /**
     * Maritime Mobile Service Identity (MMSI).
     * @type {number}
     * @memberof SourceIdentifier
     */
    pssMmsi: number;
    /**
     * Country Maritime Identification Digits (MID).
     * @type {number}
     * @memberof SourceIdentifier
     */
    countryMid: number;
    /**
     * Region identifier.
     * @type {number}
     * @memberof SourceIdentifier
     */
    regionId: number;
    /**
     * Source tag or identifier string.
     * @type {string}
     * @memberof SourceIdentifier
     */
    sourceTag: string;
    /**
     * Position in WKT format (e.g., "POINT(long lat)").
     * @type {string}
     * @memberof SourceIdentifier
     */
    pos: string;
    /**
     * Indicates if coverage is enabled for this source.
     * @type {boolean}
     * @memberof SourceIdentifier
     */
    covEnabled: boolean;
    /**
     * Time of creation in ISO 8601 format.
     * @type {Date}
     * @memberof SourceIdentifier
     */
    createdTimeUtc: Date;
    /**
     * Unique identifier for the source.
     * @type {string}
     * @memberof SourceIdentifier
     */
    uuid: string;
}

/**
 * Check if a given object implements the SourceIdentifier interface.
 */
export function instanceOfSourceIdentifier(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "pssMmsi" in value;
    isInstance = isInstance && "countryMid" in value;
    isInstance = isInstance && "regionId" in value;
    isInstance = isInstance && "sourceTag" in value;
    isInstance = isInstance && "pos" in value;
    isInstance = isInstance && "covEnabled" in value;
    isInstance = isInstance && "createdTimeUtc" in value;
    isInstance = isInstance && "uuid" in value;

    return isInstance;
}

export function SourceIdentifierFromJSON(json: any): SourceIdentifier {
    return SourceIdentifierFromJSONTyped(json, false);
}

export function SourceIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourceIdentifier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'pssMmsi': json['pss_mmsi'],
        'countryMid': json['country_mid'],
        'regionId': json['region_id'],
        'sourceTag': json['source_tag'],
        'pos': json['pos'],
        'covEnabled': json['cov_enabled'],
        'createdTimeUtc': (new Date(json['created_time_utc'])),
        'uuid': json['uuid'],
    };
}

export function SourceIdentifierToJSON(value?: SourceIdentifier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'pss_mmsi': value.pssMmsi,
        'country_mid': value.countryMid,
        'region_id': value.regionId,
        'source_tag': value.sourceTag,
        'pos': value.pos,
        'cov_enabled': value.covEnabled,
        'created_time_utc': (value.createdTimeUtc.toISOString()),
        'uuid': value.uuid,
    };
}

